import Container from "@/Components/User/Common/Container";
import BuyTicketModal from "@/Components/User/Modal/BuyTicketModal";
import ShowDetailMap from "@/Components/User/ShowDetail/ShowDetailMap";
import ShowDetailSlider from "@/Components/User/ShowDetail/ShowDetailSlider";
import { useBuy } from "@/context/buy";
import User from "@/Layouts/User";
import { Skeleton } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import { formatLongDateTime, formatMonthDayYear, getVenueTimezone } from "@/Utils/dateFormat";
import MetaTags from "@/Components/SEO/MetaTags";
import { decryptInteger, encryptInteger } from "@/Utils/encryptInteger";
import { Schema } from "@/Components/SEO/Schema";
import withBaseUrl from "@/Utils/const";
import { useLoading } from "@/context/loading";
import { DateTime } from "luxon";

export default function ShowDetailPage({ values, showsListing, error }) {
  const { isLoading } = useLoading();
  const router = useRouter();
  const [isDayPrice, setIsDayPrice] = useState(false);
  const [loading, setLoading] = useState(false);
  const [artists, setArtists] = useState();
  const { openSingleModal, openModal, setCustomModalData } = useBuy();
  const [data, setData] = useState(null);
  const [isShowExipred, setIsShowExpired] = useState(false);
  const [headLinear, setHeadLinear] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  const DEBUG_DAYPRICE =
    process.env.NEXT_PUBLIC_DEBUG_DAYPRICE === "true" ||
    process.env.NEXT_PUBLIC_DEBUG_DAYPRICE === "1";

  const computeIsDayPrice = (showValues) => {
    const venueTimezone = getVenueTimezone(showValues);

    let showAtInVenueTZ = null;

    // Prefer explicit show_date + show_time from API (these are venue-local)
    if (showValues?.show_date && showValues?.show_time) {
      showAtInVenueTZ = DateTime.fromFormat(
        `${showValues.show_date} ${showValues.show_time}`,
        "yyyy-MM-dd HH:mm:ss",
        { zone: venueTimezone }
      );
    } else if (typeof showValues?.show_at === "string") {
      // Fallback: parse show_at in venue timezone
      const showAt = showValues.show_at;
      showAtInVenueTZ =
        DateTime.fromISO(showAt, { zone: venueTimezone })?.isValid
          ? DateTime.fromISO(showAt, { zone: venueTimezone })
          : DateTime.fromFormat(showAt, "yyyy-MM-dd HH:mm:ss", { zone: venueTimezone });
    }

    if (!showAtInVenueTZ?.isValid) return false;

    const todayInVenueTZ = DateTime.now().setZone(venueTimezone).toISODate();
    const showDateInVenueTZ = showAtInVenueTZ.toISODate();
    return todayInVenueTZ === showDateInVenueTZ;
  };

  useEffect(() => {
    if (!DEBUG_DAYPRICE || !data) return;

    const venueTimezone = getVenueTimezone(data);
    let showAtInVenueTZ = null;

    if (data?.show_date && data?.show_time) {
      showAtInVenueTZ = DateTime.fromFormat(
        `${data.show_date} ${data.show_time}`,
        "yyyy-MM-dd HH:mm:ss",
        { zone: venueTimezone }
      );
    } else if (typeof data?.show_at === "string") {
      const showAt = data.show_at;
      showAtInVenueTZ =
        DateTime.fromISO(showAt, { zone: venueTimezone })?.isValid
          ? DateTime.fromISO(showAt, { zone: venueTimezone })
          : DateTime.fromFormat(showAt, "yyyy-MM-dd HH:mm:ss", { zone: venueTimezone });
    }

    const todayInVenueTZ = DateTime.now().setZone(venueTimezone).toISODate();
    const showDateInVenueTZ = showAtInVenueTZ?.isValid ? showAtInVenueTZ.toISODate() : null;

    console.log("[shows-detail][isDayPrice-venue]", {
      todayInVenueTZ,
      showDateInVenueTZ,
      isDayPrice,
    });
  }, [DEBUG_DAYPRICE, data, isDayPrice, router?.asPath, router?.query?.venue, router?.query?.slug]);
  const getShowDetail = async () => {
    if (!values?.id) return;

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "getShowDetail");
      formData.append("show_id", values.id);
      let encryptedData = localStorage.getItem("user_data");
      let decryptedData = JSON.parse(decryptInteger(encryptedData));

      if (decryptedData) {
        setIsLoggedIn(decryptedData);
      } else {
        setIsLoggedIn(null);
      }

      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageShow`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${decryptedData?.web_token}`,
          },
        }
      );

      const responseData = await response.json();

      localStorage.setItem(
        "current_data",
        encryptInteger(JSON.stringify(responseData))
      );

      setData(responseData.data);
      const showAt = responseData?.data?.show_at;

      if (!responseData.data?.is_available_for_book) {
        setIsShowExpired(true)
      } else {
        setIsShowExpired(false)
      }

      if (showAt) {
        const nextIsDayPrice = computeIsDayPrice(responseData?.data);
        setIsDayPrice(nextIsDayPrice);

        if (DEBUG_DAYPRICE) {
          const venueTimezone = getVenueTimezone(responseData?.data);
          let showAtInVenueTZ = null;

          if (responseData?.data?.show_date && responseData?.data?.show_time) {
            showAtInVenueTZ = DateTime.fromFormat(
              `${responseData.data.show_date} ${responseData.data.show_time}`,
              "yyyy-MM-dd HH:mm:ss",
              { zone: venueTimezone }
            );
          } else {
            showAtInVenueTZ =
              DateTime.fromISO(showAt, { zone: venueTimezone })?.isValid
                ? DateTime.fromISO(showAt, { zone: venueTimezone })
                : DateTime.fromFormat(showAt, "yyyy-MM-dd HH:mm:ss", { zone: venueTimezone });
          }

          console.log("[shows-detail][isDayPrice-venue]", {
            todayInVenueTZ: DateTime.now().setZone(venueTimezone).toISODate(),
            showDateInVenueTZ: showAtInVenueTZ?.isValid ? showAtInVenueTZ.toISODate() : null,
            isDayPrice: nextIsDayPrice,
          });
        }
``      } else {
        setIsDayPrice(false);
      }
    } catch (error) {
      console.error("Error fetching show details:", error);
      throw error;
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };

  useEffect(() => {
    if (values) {
      setData(values);
      setArtists([...values?.opener]);
      setHeadLinear(values.head_liner.length > 0 ? values.head_liner : null);
      getShowDetail();
    }
  }, [values]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (!data) {
    return null;
  }
  const settings2 = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          variableWidth: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          variableWidth: true,
        },
      },
    ],
  };

  const getEventSchema = (showData) => {
    const headlinerNames =
      showData.head_liner?.map((h) => h.user?.name).filter(Boolean) || [];
    const openers =
      showData.opener?.map((o) => o.user?.name).filter(Boolean) || [];

    return {
      "@context": "https://schema.org",
      "@type": "MusicEvent",
      name: showData.name,
      startDate: new Date(showData.show_at).toISOString(),
      endDate: new Date(showData.show_ends_at).toISOString(),
      location: {
        "@type": "MusicVenue",
        name: showData.venue?.name,
        address: {
          "@type": "PostalAddress",
          addressLocality: showData.venue?.city,
          addressRegion: showData.venue?.state,
          streetAddress: showData.venue?.address,
        },
      },
      image: showData.banner,
      description: showData.description,
      url: `https://qoncertapp.com/shows/${showData.venue?.city?.toLowerCase()}-${showData.venue?.state?.toLowerCase()}/${showData.name
        ?.toLowerCase()
        .replace(/\s+/g, "-")}-${showData.venue?.name
        ?.toLowerCase()
        .replace(/\s+/g, "-")}-${showData.show_date.replace(/-/g, "")}`,
      performer: [
        ...headlinerNames.map((name) => ({ "@type": "MusicGroup", name })),
        ...openers.map((name) => ({ "@type": "MusicGroup", name })),
      ],
      eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
      eventStatus: "https://schema.org/EventScheduled",
    };
  };

  const getShowFAQs = (showData) => {
    if (!showData) return null;

    return [
      {
        question: `What time does ${showData.name} start?`,
        answer: `The show starts at ${new Date(
          showData.show_at
        ).toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
        })}. Doors typically open 1 hour before the show.`,
      },
      {
        question: `Where is ${showData.name} taking place?`,
        answer: `The show is at ${showData.venue?.name}, located at ${showData.venue?.address}, ${showData.venue?.city}, ${showData.venue?.state}.`,
      },
      {
        question: `Who is performing at ${showData.name}?`,
        answer: `The show features ${showData.head_liner
          ?.map((h) => h.user?.name)
          .join(", ")}${
          showData.opener?.length
            ? ` with opening acts ${showData.opener
                ?.map((o) => o.user?.name)
                .join(", ")}`
            : ""
        }.`,
      },
      {
        question: `How can I get tickets for ${showData.name}?`,
        answer: `Tickets can be purchased directly through Qoncert. ${
          showData.price
            ? `Tickets start at $${showData.price}.`
            : "Ticket prices vary."
        }`,
      },
    ];
  };

  const getBreadcrumbs = (showData) => {
    if (!showData) return null;

    return [
      {
        name: "Home",
        url: withBaseUrl("/"),
      },
      {
        name: "Shows",
        url: withBaseUrl("/shows"),
      },
      {
        name: showData.name,
        url: withBaseUrl(
          `/shows/${showData.venue?.city?.toLowerCase()}-${showData.venue?.state?.toLowerCase()}/${showData.name
            ?.toLowerCase()
            .replace(/\s+/g, "-")}-at-${showData.venue?.name
            ?.toLowerCase()
            .replace(/\s+/g, "-")}-on-${showData.show_date.replace(/-/g, "")}`
        ),
      },
    ];
  };

  return (
    <User>
      <Head>
        <title>{`${data?.name} | Qoncert App`}</title>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getEventSchema(data)),
          }}
        />
        <Schema faqs={getShowFAQs(data)} breadcrumbs={getBreadcrumbs(data)} />
      </Head>
      <MetaTags
        showData={data}
        canonicalUrl={`/shows/${data?.venue?.city?.toLowerCase()}-${data?.venue?.state?.toLowerCase()}/${data?.name
          ?.toLowerCase()
          .replace(/\s+/g, "-")}-at-${data?.venue?.name
          ?.toLowerCase()
          .replace(/\s+/g, "-")}-on-${data?.show_date
          ?.toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/(^-|-$)/g, "")}`}
        ogImage={data?.banner}
        keywords={`${data?.name}, concert, live music, ${data?.venue?.name}, ${
          data?.venue?.city
        }, ${data?.venue?.state}, tickets, music event, ${data?.head_liner
          ?.map((h) => h.user?.name)
          .join(", ")}`}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={!isLoading ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 0.5 }}
        style={{ backgroundImage: `url(${data?.banner})` }}
        className="layout_bg_image hidden lg:block"
      >
        <span className="bg_inner_shadow"></span>
      </motion.div>
      <Container className="relative gradient-skeleton -mt-[97px] lg:mt-[83px] ">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={!isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="hidden lg:block relative z-9 lg:px-[161px] py-10 pt-6"
        >
          <h1 className="font-[700] text-white text-[45px] leading-[40px]">
            {data?.name}
          </h1>
        </motion.div>
        <AnimatePresence>
          {!loading && openModal.buy && (
            <AnimatePresence>
              <div className="absolute">
                <BuyTicketModal showData={data} />
              </div>
            </AnimatePresence>
          )}
        </AnimatePresence>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={!isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <div className="lg:pt-10 lg:pl-[153px] lg:pr-[150px] ">
            <div className="lg:flex showDetailHero items-start gap-[99px] ">
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={
                  !isLoading
                    ? { opacity: 1, scale: 1 }
                    : { opacity: 0, scale: 0.95 }
                }
                transition={{ duration: 0.5, delay: 0.6 }}
                className="pt-4"
              >
                <img
                  src={data?.banner}
                  className="w-screen lg:min-w-[400px] lg:max-w-[400px] h-[450px] lg:h-auto object-cover lg:aspect-square lg:rounded-lg"
                  alt=""
                />
              </motion.div>
              <div className=" lg:hidden absolute z-9 bottom-0 w-full left-0 px-6 py-4 ">
                <p className="w-fit bg-[#0D0C0F] text-[14px] leading-[10px] text-[#F9F9F9] py-2 px-[6px] rounded-2xl  ">
                  {data?.restriction}
                </p>
                <div className="mt-4">
                  <p className=" text-2xl leading-[32px] font-[700] ">
                    {data?.name}
                  </p>
                  <p className="mt-2 text-[14px] text-[#9E9E9E]  ">
                    {" "}
                    {data?.show_date
                      ? formatMonthDayYear(data.show_date)
                      : ""}{" "}
                    | {data?.venue?.city}, {data?.venue?.state}
                  </p>
                </div>
                {!isShowExipred && (
                  <div className="flex flex-col lg:flex-row gap-3 mt-4 w-full">
                    {data?.is_ticket_booked && (
                      <button
                        onClick={() =>
                          router.push(`/tickets/${data?.booking_id}`)
                        }
                        className="view_ticket_btn w-full lg:w-3/4 rounded-[12px]"
                      >
                        <p className="py-3 text-lg font-[900] leading-[22px]">
                          View Ticket
                        </p>
                      </button>
                    )}
                    <button
                      onClick={() => {
                        if (data.venue_ticket_web_link) {
                          openSingleModal("custom");
                          setCustomModalData({
                            showId: data.id,
                            link: data.venue_ticket_web_link,
                          });
                          return;
                        }

                        if (data?.venue?.can_buy_tickets) {
                          openSingleModal("buy");
                        }
                      }}
                      className={`
                        ${
                          data?.venue?.can_buy_tickets
                            ? "main_btn_bg"
                            : "disableBuyTicket"
                        }
                        ${data?.is_ticket_booked ? "lg:w-2/4" : "w-full"} 
                        rounded-[12px]
                      `}
                    >
                      <p className="py-3 text-lg font-[900] leading-[22px]">
                        Get Tickets
                      </p>
                    </button>
                  </div>
                )}
              </div>
              <div className="hidden overflow-hidden w-full lg:block">
                <Slider {...settings2}>
                  {(headLinear && headLinear.length > 0
                    ? headLinear
                    : [data?.created_by]
                  ).map((item, index) => {
                    const isSingle = !headLinear || headLinear.length == 1;
                    return (
                      <div key={index} className="!w-fit pr-6 ">
                        <div className="flex gap-3 items-center p-2">
                          <img
                            src={
                              item.user
                                ? item.user?.profile
                                : item?.national_id
                                ? item?.national?.photo
                                : item?.profile
                            }
                            className={
                              isSingle
                                ? "lg:w-[83px] w-[60px] aspect-square cursor-pointer rounded-full"
                                : "min-w-12 w-12 h-12 rounded-full overflow-hidden cursor-pointer"
                            }
                            onClick={() =>
                              router.push(
                                `/artist/${
                                  item.user
                                    ? item.user?.username
                                    : item?.national_id
                                    ? item?.national?.username
                                    : item?.username
                                }`
                              )
                            }
                            alt=""
                          />
                          <div className="whitespace-nowrap">
                            <p
                              className={
                                isSingle
                                  ? "lg:text-[28px] text-[20px] lg:font-[600] lg:leading-[32px] truncate"
                                  : "text-base font-[600] leading-[24px] line-clamp-1  lg:text-base lg:leading-[24px] lg:font-[600]"
                              }
                            >
                              {item.user
                                ? item.user?.name
                                : item?.national_id
                                ? item?.national?.name
                                : item?.name}
                            </p>
                            <p
                              className={
                                isSingle
                                  ? "text-[#9E9E9E] lg:text-lg text-sm lg:leading-[32px] tracking-[1px] font-[500] truncate"
                                  : "text-[#9E9E9E] text-sm lg:text-sm lg:leading-[28px] tracking-[1px] font-[500] truncate"
                              }
                            >
                              {item.user
                                ? item.user?.account_type?.split(",")[0]
                                : item?.national_id
                                ? item?.national?.account_type?.split(",")[0]
                                : item?.account_type?.split(",")[0]}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>

                <div className="mt-[54px] ">
                  <div className=" flex items-center lg:gap-5 ">
                    <svg
                      width="24"
                      height="26"
                      viewBox="0 0 24 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.20801 13.9049C1.20801 5.78954 3.91351 3.08521 12.0277 3.08521C20.143 3.08521 22.8485 5.78954 22.8485 13.9049C22.8485 22.0202 20.143 24.7245 12.0277 24.7245C3.91351 24.7245 1.20801 22.0202 1.20801 13.9049Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1.5293 9.87801H22.5386"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M17.167 14.4713H17.1775"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12.0341 14.4713H12.0446"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M6.89156 14.4713H6.90206"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M17.167 18.9652H17.1775"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12.0341 18.9652H12.0446"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M6.89156 18.9652H6.90206"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.7054 1.39185V5.19751"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.36165 1.39185V5.19751"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p className=" lg:font-[700] lg:text-2xl lg:leading-[33px] ">
                      {formatLongDateTime(data.show_date, data.show_time)}
                    </p>
                  </div>
                  <div className=" lg:mt-[22px] flex items-center lg:gap-5 ">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.5864 4.19995V7.29774"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.5864 20.4678V23.0579"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.5864 16.9679V10.7979"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M25.0837 16.392C21.9445 16.392 21.9445 11.6067 25.0837 11.6067C25.0837 6.06218 25.0837 4.08325 14.0003 4.08325C2.91699 4.08325 2.91699 6.06218 2.91699 11.6067C6.05619 11.6067 6.05619 16.392 2.91699 16.392C2.91699 21.9377 2.91699 23.9166 14.0003 23.9166C25.0837 23.9166 25.0837 21.9377 25.0837 16.392Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <div className=" lg:font-[700] lg:text-2xl lg:leading-[33px] ">
                      {isDayPrice ? (
                        <p>
                          Day Of Show $
                          {data?.day_of_show_price ?? data?.ticket_price}
                        </p>
                      ) : (
                        <p>
                          Advance ${data?.ticket_price}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className=" lg:mt-7 flex items-center lg:gap-5 ">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.1607 11.0224V8.51756C19.1607 5.58573 16.783 3.20806 13.8512 3.20806C10.9194 3.19523 8.53236 5.56123 8.51953 8.49423V8.51756V11.0224"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.2975 24.7913H9.38298C6.93998 24.7913 4.95898 22.8115 4.95898 20.3673V15.3635C4.95898 12.9193 6.93998 10.9395 9.38298 10.9395H18.2975C20.7405 10.9395 22.7215 12.9193 22.7215 15.3635V20.3673C22.7215 22.8115 20.7405 24.7913 18.2975 24.7913Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.8402 16.5698V19.161"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p className=" lg:font-[700] lg:text-2xl lg:leading-[33px] ">
                      Restrictions: {data?.restriction}
                    </p>
                  </div>
                  <div className="lg:mt-7 lg:pb-[14px] flex items-center lg:gap-5 ">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.929 12.4954C16.929 10.8839 15.6233 9.57812 14.0118 9.57812C12.4015 9.57812 11.0957 10.8839 11.0957 12.4954C11.0957 14.1057 12.4015 15.4115 14.0118 15.4115C15.6233 15.4115 16.929 14.1057 16.929 12.4954Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.9994 24.5C10.6184 24.5 5.25 18.6184 5.25 12.3651C5.25 7.46954 9.16662 3.5 13.9994 3.5C18.8322 3.5 22.75 7.46954 22.75 12.3651C22.75 18.6184 17.3816 24.5 13.9994 24.5Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p className=" lg:font-[700] lg:text-2xl lg:leading-[33px] ">
                      {data?.venue?.name} • {data?.venue?.city},{" "}
                      {data?.venue?.state}
                    </p>
                  </div>
                </div>
                {!isShowExipred && (
                  <div className="flex flex-col lg:flex-row gap-3 mt-[49px] w-full lg:w-[450px]">
                    {data?.is_ticket_booked && !loading && (
                      <button
                        onClick={() =>
                          router.push(`/tickets/${data?.booking_id}`)
                        }
                        className="view_ticket_btn w-full lg:w-2/4 rounded-xl"
                      >
                        <p className="lg:py-[21px] lg:font-[900] lg:text-[28px] lg:leading-[22px]">
                          View Ticket
                        </p>
                      </button>
                    )}
                    <button
                      onClick={() => {
                        if (data.venue_ticket_web_link) {
                          openSingleModal("custom");
                          setCustomModalData({
                            showId: data.id,
                            link: data.venue_ticket_web_link,
                          });
                          return;
                        }

                        if (data?.venue?.can_buy_tickets) {
                          openSingleModal("buy");
                        }
                      }}
                      className={`
                        ${
                          loading
                            ? "mb-3"
                            : data?.is_ticket_booked
                            ? "lg:w-2/4"
                            : "w-full"
                        } 
                        ${
                          data?.venue?.can_buy_tickets
                            ? "main_btn_bg"
                            : "disableBuyTicket"
                        } 
                        rounded-xl
                      `}
                    >
                      {loading ? (
                        <Skeleton
                          variant="rectangular"
                          className="w-full py-8 rounded-md h-full"
                        />
                      ) : (
                        <p className="lg:py-[21px] lg:font-[900] lg:text-[28px] lg:leading-[22px]">
                          Get Tickets
                        </p>
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className=" w-full overflow-hidden px-6 lg:pt-[37px] lg:pl-[153px] lg:pr-[150px] py-5"
            initial={{ opacity: 0, y: 20 }}
            animate={!isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={
                !isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
              }
              transition={{ duration: 0.5, delay: 1.0 }}
              className="mb-[30px] lg:hidden"
            >
              <p className="text-xl font-[700] leading-[32px]">
                {headLinear
                  ? headLinear.length == 1
                    ? "Headliner"
                    : "Headliners"
                  : "Created By"}
              </p>
              {headLinear && headLinear.length > 0 ? (
                <Slider {...settings2}>
                  {headLinear.map((item, index) => (
                    <div
                      key={index}
                      onClick={() =>
                        router.push(
                          `/artist/${
                            item?.user
                              ? item.user.username
                              : item?.national_id
                              ? item?.national?.username
                              : ""
                          }`
                        )
                      }
                      className="!w-fit"
                    >
                      <div className="mt-4 gap-3 flex items-center px-1">
                        <img
                          src={
                            item?.user
                              ? item?.user?.profile
                              : item?.national_id
                              ? item?.national?.profile
                              : ""
                          }
                          className="w-12 h-12 object-cover rounded-full"
                          alt=""
                        />
                        <div className="whitespace-nowrap">
                          <p className="text-base leading-[24px] font-[600] truncate">
                            {item?.user
                              ? item?.user?.name
                              : item?.national_id
                              ? item?.national?.name
                              : ""}
                          </p>
                          <p className="text-[#9E9E9E] text-sm leading-[20px] font-[500] truncate">
                            {item?.user
                              ? item?.user?.account_type
                              : item?.national_id
                              ? item?.national?.account_type
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              ) : (
                <div
                  onClick={() =>
                    router.push(
                      `/artist/${
                        data?.created_by
                          ? data?.created_by?.username
                          : data?.national_id
                          ? data?.national?.username
                          : ""
                      }`
                    )
                  }
                  className="mt-4 gap-3 flex items-center cursor-pointer"
                >
                  <img
                    src={
                      data?.created_by
                        ? data?.created_by?.profile
                        : data?.national_id
                        ? data?.national?.profile
                        : ""
                    }
                    className="w-12 h-12 object-cover rounded-full"
                    alt=""
                  />
                  <div className="whitespace-nowrap">
                    <p className="text-base leading-[24px] font-[600] truncate">
                      {data.created_by?.name}
                    </p>
                    <p className="text-[#9E9E9E] text-sm leading-[20px] font-[500] truncate">
                      {data.created_by?.account_type}
                    </p>
                  </div>
                </div>
              )}
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={
                !isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
              }
              transition={{ duration: 0.5, delay: 1.2 }}
              className={`lg:pl-[400px] lg:pt-[29px] ${
                artists.length == 0 ? "hidden" : ""
              }`}
            >
              <div className=" lg:pt-5 ">
                <p className="hidden lg:block font-[700] lg:text-[30px] lg:leading-[26px] ">
                  Also Performing
                </p>
                <p className=" lg:hidden font-[700] text-lg leading-[32px] ">
                  Openers
                </p>
              </div>
              <div className=" mt-4 lg:mt-[56px] ">
                <Slider data={artists.length} {...settings}>
                  {artists && artists.length == 0 ? (
                    <div></div>
                  ) : (
                    artists &&
                    artists.map((artist, idx) => {
                      return (
                        <div key={idx} className="relative   pl-2 ">
                          <div className="flex gap-3 items-center">
                            <div className="max-w-12 min-w-12 cursor-pointer w-full h-12 rounded-full overflow-hidden">
                              <img
                                className="h-full object-cover"
                                onClick={() =>
                                  router.push(
                                    `/artist/${
                                      artist.user
                                        ? artist.user?.username
                                        : artist?.national_id
                                        ? artist?.national?.username
                                        : ""
                                    }`
                                  )
                                }
                                src={
                                  artist?.national_id
                                    ? artist?.national.photo
                                    : artist.user?.profile || userImg
                                }
                                alt={artist.user?.name || "Artist"}
                              />
                            </div>
                            <div>
                              <p className="text-base font-[600] leading-[24px] line-clamp-1  lg:text-base lg:leading-[24px] lg:font-[600]">
                                {artist?.national_id
                                  ? artist?.national?.name
                                  : artist.user?.name || "Unknown Artist"}
                              </p>
                              <span className="text-xs text-[#9CA4AB] leading-[20px] font-[500]">
                                {artist?.user
                                  ? artist?.user?.account_type.split(",")[0]
                                  : artist?.national?.account_type.split(
                                      ","
                                    )[0]}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </Slider>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={
                !isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
              }
              transition={{ duration: 0.5, delay: 1.4 }}
              className="mt-[30px] lg:mt-[71px] lg:pl-[400px] lg:pt-[29px]"
            >
              <p className="hidden lg:block lg:text-[30px] lg:leading-[26px] lg:font-[700]">
                Show Details
              </p>
              <p className="pb-4 lg:hidden text-xl font-[700] leading-[32px]">
                Details
              </p>
              <motion.div
                initial={{ opacity: 0 }}
                animate={!isLoading ? { opacity: 1 } : { opacity: 0 }}
                transition={{ duration: 0.5, delay: 1.6 }}
                className={`${
                  !loading &&
                  "lg:mt-[71px] whitespace-pre-line text-white lg:text-[#C7C7CC] text-base leading-[22px] lg:text-2xl lg:leading-[30px] font-[500]"
                }`}
              >
                {loading ? (
                  <div className="w-full h-[180px] lg:h-[317px]">
                    <Skeleton variant="text" width="100%" height="100%" />
                  </div>
                ) : !isLoggedIn && data.fan_description?.trim() ? (
                  data.fan_description
                ) : (
                  data.description
                )}
              </motion.div>
            </motion.div>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={!isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, delay: 1.8 }}
            className="px-6 pt-[30px] lg:pt-[37px] lg:pb-10 lg:pl-[153px] lg:pr-[150px]"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={
                !isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
              }
              transition={{ duration: 0.5, delay: 2.0 }}
              className="lg:pt-[29px] lg:pl-[400px]"
            >
              <p className="font-[700] lg:text-[30px] lg:leading-[26px]">
                Location
              </p>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={
                  !isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
                }
                transition={{ duration: 0.5, delay: 2.2 }}
                className="lg:mt-[54px]"
              >
                <div className="text-[#F2F2F7] lg:text-2xl lg:leading-[24px] font-[700]">
                  {loading ? (
                    <div className="w-[30%] lg:w-[350px] h-[25px] lg:h-[40px]">
                      <Skeleton variant="text" width="100%" height="100%" />
                    </div>
                  ) : (
                    data.venue?.name
                  )}
                </div>
                <div className="mt-2 lg:mt-4 text-[#D1D1D6] lg:text-2xl lg:leading-[24px] font-[500]">
                  {loading ? (
                    <div className="w-[30%] lg:w-[350px] h-[25px] lg:h-[40px]">
                      <Skeleton variant="text" width="100%" height="100%" />
                    </div>
                  ) : (
                    `${
                      data.venue?.address?.trim().endsWith(",")
                        ? data.venue.address.trim()
                        : `${data.venue?.address?.trim()},`
                    } ${data.venue?.city || ""} ${data.venue?.state || ""}`
                  )}
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={
                  !isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
                }
                transition={{ duration: 0.5, delay: 2.4 }}
                className="pt-[30px] lg:pt-[54px]"
              >
                <ShowDetailMap
                  lat={data.venue?.latitude}
                  lng={data.venue?.longitude}
                  image={data.venue?.logo}
                />
              </motion.div>
            </motion.div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={!isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, delay: 2.6 }}
            className="px-6 mt-7 py-5 border-t border-[#FFFFFF1A] lg:pt-10 lg:pl-[75px]"
          >
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={
                !isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
              }
              transition={{ duration: 0.5, delay: 2.8 }}
              className="hidden lg:block text-2xl leading-[32px] font-[700]"
            >
              Other Shows This Month
            </motion.p>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={
                !isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
              }
              transition={{ duration: 0.5, delay: 2.8 }}
              className="lg:hidden text-2xl leading-[32px] font-[700]"
            >
              Shows This Month
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={
                !isLoading ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
              }
              transition={{ duration: 0.5, delay: 3.0 }}
              className="mt-6"
            >
              <ShowDetailSlider data={showsListing?.data} />
            </motion.div>
          </motion.div>
        </motion.div>
      </Container>
    </User>
  );
}

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div
      style={{ zIndex: 9 }}
      className="slider_custom_next_arrow_shadow right-0 w-[161px] h-[90px] md:h-[90px] flex items-center justify-end top-[-20px]"
      onClick={onClick}
    >
      <div className="">
        <div className="slider_custom_next_arrow">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.42467 17.225C7.26634 17.225 7.10801 17.1667 6.98301 17.0417C6.74134 16.8 6.74134 16.4 6.98301 16.1583L12.4163 10.725C12.8163 10.325 12.8163 9.67502 12.4163 9.27502L6.98301 3.84168C6.74134 3.60002 6.74134 3.20002 6.98301 2.95835C7.22467 2.71668 7.62467 2.71668 7.86634 2.95835L13.2997 8.39168C13.7247 8.81668 13.9663 9.39168 13.9663 10C13.9663 10.6083 13.733 11.1833 13.2997 11.6083L7.86634 17.0417C7.74134 17.1583 7.58301 17.225 7.42467 17.225Z"
              fill="#F9F9F9"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps(context) {
  const { slug = [] } = context.params || {};
  const lastSegment = slug;

  if (!lastSegment) return { notFound: true };

  const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL;

  try {
    const showId = lastSegment.split("-for-")[0];
    const isValidId = !isNaN(showId); // Check if it's a number

    let data;
    const formShowsData = new FormData();
    formShowsData.append("action", "getShow");
    formShowsData.append("by_period", "month");

    const headers = { Accept: "application/json" };

    if (isValidId) {
      console.log("Calling getShowDetail API using show_id:", showId);

      const formData = new FormData();
      formData.append("action", "getShowDetail");
      formData.append("show_id", showId);

      const [detailRes, listingRes] = await Promise.all([
        fetch(`${BACKEND_URL}/webapi/manageShow`, {
          method: "POST",
          body: formData,
        }).then((res) => res.json()),
        fetch(`${BACKEND_URL}/webapi/manageShow`, {
          method: "POST",
          body: formShowsData,
          headers,
        }).then((res) => res.json()),
      ]);

      data = detailRes;
      if (!data?.status || !data?.data) return { notFound: true };

      return {
        props: {
          values: data.data,
          showsListing: listingRes || null,
          error: null,
        },
        revalidate: 180,
      };
    } else {
      const showNamePart = lastSegment
        .split("-on-")[0]
        ?.split("-at-")[0]
        ?.replace(/-/g, " ");
      const showDatePart = lastSegment.split("-on-")[1];

      console.log("Calling getShowDetail_v2 API using name and date:", {
        show_name: showNamePart,
        show_date: showDatePart,
      });

      const formData = new FormData();
      formData.append("action", "getShowDetail_v2");
      formData.append("show_name", showNamePart);
      formData.append("show_date", showDatePart);

      const [detailRes, listingRes] = await Promise.all([
        fetch(`${BACKEND_URL}/webapi/manageShow`, {
          method: "POST",
          body: formData,
        }).then((res) => res.json()),
        fetch(`${BACKEND_URL}/webapi/manageShow`, {
          method: "POST",
          body: formShowsData,
          headers,
        }).then((res) => res.json()),
      ]);

      data = detailRes;
      if (!data?.status || !data?.data) return { notFound: true };

      return {
        props: {
          values: data.data,
          showsListing: listingRes || null,
          error: null,
        },
        revalidate: 180,
      };
    }
  } catch (error) {
    console.error("Error fetching show data:", error);
    return {
      props: {
        notFound: true,
      },
      revalidate: 180,
    };
  }
}
